// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_a3-3";
export var contentContainer = "_a3-0";
export var editorContainer = "_a3-1";
export var quillInputForm = "_a3-2";
export var zoneDivider = "_a3-4";